import React, { useState } from 'react';
import css from './SearchSection.module.css';
import { useHistory } from 'react-router-dom';

const SearchSection = ({
  onSearch,
  placeholder = '',
  heading = "OR, SEARCH FOR WHAT YOU'RE LOOKING FOR",
  searchIcon,
}) => {
  const [searchValue, setSearchValue] = useState('');
  const history = useHistory();

  const handleInputChange = e => {
    setSearchValue(e.target.value);
  };

  const handleSubmit = e => {
    e.preventDefault();
    history.push(`/s?keywords=${searchValue}`);
  };

  const handleKeyPress = e => {
    if (e.key === 'Enter') {
      handleSubmit(e);
    }
  };

  return (
    <div className={css.searchContainer}>
      <div className={css.searchContainerInner}>
        <h4>{heading}</h4>
        <form onSubmit={handleSubmit} className={css.searchContainerInput}>
          <span className={css.searchIcon}>
            <img src={searchIcon} alt="search" />
          </span>
          <input
            type="text"
            placeholder={placeholder}
            value={searchValue}
            onChange={handleInputChange}
            onKeyPress={handleKeyPress}
          />
        </form>
      </div>
    </div>
  );
};

export default SearchSection;
